import React, { useState } from 'react';
import { NavLink as NavLinkRRD, Link, useLocation } from 'react-router-dom';
import {
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  DropdownToggle,
} from 'reactstrap';
import { useUser } from 'context';
import config from 'config';
import adminRoutes from 'admin_routes';

import { default as Logo } from 'assets/img/brand/logo.png';

function Sidebar() {
  const location = useLocation();
  const user = useUser();

  const [collapseOpen, setCollapseOpen] = useState(false);

  const toggleCollapse = () => {
    setCollapseOpen(!collapseOpen);
  };

  const closeCollapse = () => {
    setCollapseOpen(false);
  };

  return (
    <Navbar className="navbar-vertical fixed-left navbar-light bg-white" expand="md" id="sidenav-main">
      <Container fluid className="d-flex d-md-block justify-content-between align-items-center">
        <button
          className="navbar-toggler"
          type="button"
          onClick={ () => toggleCollapse() }
          style={{ padding: 0 } }
        >
          <span className="navbar-toggler-icon" />
        </button>

        <NavbarBrand className="pt-0 pb-0">
          <img className="navbar-brand-img" src={ Logo } width='190px' />
        </NavbarBrand>

        <div className="small text-right text-light font-weight-bold d-none d-md-block">
          v{ config.version }{ config.build ? '(' + config.build + ')' : '' }
          { config.env !== 'prod' ? ` - ${ config.env }` : '' }
        </div>

        <Nav className="align-items-center d-flex d-md-none" navbar>
          <UncontrolledDropdown nav>
            <DropdownToggle className="d-flex flex-column align-items-center" nav>
              <span style={{
                display: 'block',
                width: '3px',
                height: '3px',
                borderRadius: '50%',
                margin: '2px',
                background: '#66615B',
              }} />
              <span style={{
                display: 'block',
                width: '3px',
                height: '3px',
                borderRadius: '50%',
                margin: '2px',
                background: '#66615B',
              }} />
              <span style={{
                display: 'block',
                width: '3px',
                height: '3px',
                borderRadius: '50%',
                margin: '2px',
                background: '#66615B',
              }} />
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-arrow">
              <DropdownItem className="noti-title" header tag="div">
                <h6 className="text-overflow m-0">Bienvenido!</h6>
              </DropdownItem>
              <DropdownItem to="/admin/profile" tag={Link}>
                <i className="ni ni-single-02" />
                <span>Editar perfil</span>
              </DropdownItem>
              <DropdownItem to="/auth/change-password" tag={Link}>
                <i className="ni ni-key-25" />
                <span>Cambiar contraseña</span>
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem>
                <i className="ni ni-user-run" />
                <span>Cerrar sesión</span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>

        <Collapse navbar isOpen={ collapseOpen }>
          <div className="navbar-collapse-header d-md-none">
            <Row>
              <Col className="collapse-brand" xs="6">
                <Link to="/admin/solicitudes">
                  <img className="navbar-brand-img" src={ Logo } />
                </Link>
              </Col>
              <Col className="collapse-close" xs="6">
                <button className="navbar-toggler" type="button" onClick={() => toggleCollapse()} >
                  <span />
                  <span />
                </button>
              </Col>
            </Row>
          </div>
          <Nav navbar>
            {
              adminRoutes.map((item, key) => {
                if (!item.show) {
                  return;
                }

                if ('roles' in item && !user.is(item.roles)) {
                  return;
                }

                return (
                  <NavItem key={ key } active={ location.pathname === item.layout + item.path }>
                    <NavLink
                      end
                      active={ location.pathname === item.layout + item.path }
                      to={ item.layout + item.path }
                      tag={ NavLinkRRD }
                      onClick={ () => closeCollapse() }
                    >
                      <i className={item.icon} /> { item.name }
                    </NavLink>
                  </NavItem>
                );
              })
            }
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
}

export default Sidebar;
